import {
  FilterKey,
  HandleChangeFilter,
} from '@/components/common/table-filter';
import {
  computed,
  defineComponent,
  reactive,
  SetupContext,
} from '@vue/composition-api';
import dayjs from 'dayjs';

type DateProps = {
  value: string;
  validate?: (value: string) => boolean;
};

type Props = {
  name: FilterKey;
  item: DateProps & {
    rangeProps: DateProps;
  };
  onChange: HandleChangeFilter;
};

export default defineComponent({
  setup(_, ctx: SetupContext) {
    const state = reactive({
      isOpenStartDate: false,
      isOpenEndDate: false,
    });

    const props = {
      ...ctx.attrs,
      onChange: ctx.attrs['on-change'],
    } as Props;

    const handleChange = (date: Date, isEndDate = false) => {
      const dateStr = dayjs(date).format('YYYY/MM/DD');

      if (isEndDate) {
        props.onChange(props.name, dateStr, true);
      } else {
        props.onChange(props.name, dateStr);
      }
    };

    const clear = (isEndDate = false) => {
      if (isEndDate) {
        props.onChange(props.name, undefined, true);
      } else {
        props.onChange(props.name, undefined);
      }
    };

    const date = computed(() => props.item.value?.replace('/', '-'));

    const time = computed(() =>
      props.item.rangeProps?.value?.replace('/', '-'),
    );

    return {
      state,
      item: props.item,
      date,
      time,
      handleChange,
      clear,
    };
  },
});
